import * as React from 'react';
import { cn } from '../../lib/utils';

function Card({ className, ...props }) {
  return <div className={cn('ba-card', className)} {...props} />;
}

function CardHeader({ className, ...props }) {
  return <div className={cn('flex flex-col gap-1.5 p-6 pb-4', className)} {...props} />;
}

function CardTitle({ className, children, ...props }) {
  return <h3 className={cn('text-lg font-bold leading-none', className)} {...props}>{children}</h3>;
}

function CardDescription({ className, ...props }) {
  return <p className={cn('ba-muted', className)} {...props} />;
}

function CardContent({ className, ...props }) {
  return <div className={cn('p-6 pt-0', className)} {...props} />;
}

function CardFooter({ className, ...props }) {
  return <div className={cn('flex items-center p-6 pt-0', className)} {...props} />;
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
